import { parseDomains } from '@/utils/domains'
import { getEnvValue, parseBoolean, parseNumber } from './utils'

export const API_URL = getEnvValue('API_URL') ?? ''
export const API_DOMAIN = API_URL.slice(0, -8)
export const MAX_LINK = getEnvValue('MAX_LINK') ?? null

export const API_CLIENT_ID = getEnvValue('API_CLIENT_ID')
export const API_CLIENT_SECRET = getEnvValue('API_CLIENT_SECRET')

// DOMAINS
export const MKTU_LANDING_DOMAINS = parseDomains(
  getEnvValue('MKTU_LANDING_DOMAINS')
)

export const SITE_DOMAINS = parseDomains(getEnvValue('SITE_DOMAINS'))

export const ONLINE_SEARCH_DOMAINS = parseDomains(
  getEnvValue('ONLINE_SEARCH_DOMAINS')
)

export const MINIAPP_DOMAINS = parseDomains(getEnvValue('WEB_APP_DOMAINS'))

export const MINIAPP_PROTOCOL =
  getEnvValue('WEB_APP_PROTOCOL') === 'http' ? 'http' : 'https'

export const WHEEL_OF_FORTUNE_DOMAINS = parseDomains(
  getEnvValue('WHEEL_OF_FORTUNE_DOMAINS')
)

export const WHEEL_OF_FORTUNE_PROTOCOL =
  getEnvValue('WHEEL_OF_FORTUNE_PROTOCOL') === 'http' ? 'http' : 'https'

// Задержка (в секундах) до автоматического открытия виджета «Колесо Фортуны»
const wheelWidgetDelaySeconds = parseNumber('WHEEL_WIDGET_DELAY', 10)

export const WHEEL_WIDGET_DELAY = Number.isNaN(wheelWidgetDelaySeconds)
  ? 10_000
  : wheelWidgetDelaySeconds * 1000

// SEO
export const WITH_YANDEX_METRIKA = parseBoolean('WITH_YANDEX_METRIKA')

export const YANDEX_METRIKA_COUNTER = getEnvValue('YANDEX_METRIKA_COUNTER')

export const WITH_CALLTOUCH = parseBoolean('WITH_CALLTOUCH')

// SETTINGS MODULES
export const WITH_SETTINGS_THEME = parseBoolean('WITH_SETTINGS_THEME')
export const ONLINE_PAYMENT_ENABLED = parseBoolean('ONLINE_PAYMENT_ENABLED')
export const EXTENSION_OF_RIGHTS_ENABLED = parseBoolean(
  'EXTENSION_OF_RIGHTS_ENABLED'
)
export const USER_DOCUMENTS_ENABLED = parseBoolean('USER_DOCUMENTS_ENABLED')
export const PROMOCODE_ENABLED = parseBoolean('PROMOCODE_ENABLED')
export const ONBOARDING_ENABLED = parseBoolean('ONBOARDING_ENABLED')

// FOR CALCULATOR
export const TAX_DEFAULT = 17_000
export const PRICE_MKTU_CLASS = 3_500
export const PRICE_MKTU_WORD = 500
export const TAX_CERTIFICATE_PRIMARY = 18_000
export const PRICE_MKTU_CLASS_FOR_CERTIFICATE = 2_000
